import { useEffect, useState } from "react";
import { api } from "../../api";

interface Entry {
  id: string;
  email?: string;
  domain?: string;
  reason?: string;
  source?: string;
  created_at: number;
}

export function GrowthSuppression() {
  const [entries, setEntries] = useState<Entry[]>([]);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [domain, setDomain] = useState("");
  const [reason, setReason] = useState("");

  async function load() {
    setLoading(true);
    try {
      const r = await api.listGrowthSuppression();
      setEntries((r.entries as Entry[]) ?? []);
    } finally { setLoading(false); }
  }
  useEffect(() => { load(); }, []);

  async function add() {
    if (!email.trim() && !domain.trim()) return;
    await api.addGrowthSuppression({
      email: email.trim() || undefined,
      domain: domain.trim() || undefined,
      reason: reason.trim() || undefined,
      source: "manual",
    });
    setEmail(""); setDomain(""); setReason("");
    load();
  }

  async function remove(id: string) {
    if (!confirm("Remove from suppression list? They will be eligible for outreach again.")) return;
    await api.removeGrowthSuppression({ id });
    load();
  }

  return (
    <div>
      <div className="sg-panel" style={{ marginBottom: 18 }}>
        <div className="sg-panel-pad">
          <h3 style={{ marginTop: 0, fontSize: 16 }}>Add to suppression list</h3>
          <div className="sg-muted" style={{ fontSize: 13, marginBottom: 10 }}>
            Anything on this list is excluded from all outreach. Add an email, a domain, or both.
          </div>
          <div className="sg-row" style={{ gap: 8, flexWrap: "wrap" }}>
            <input className="sg-input" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
            <input className="sg-input" placeholder="Domain" value={domain} onChange={(e) => setDomain(e.target.value)} />
            <input className="sg-input" placeholder="Reason (optional)" value={reason} onChange={(e) => setReason(e.target.value)} style={{ flex: 1, minWidth: 160 }} />
            <button className="sg-btn sg-btn-primary sg-btn-sm" onClick={add}>Add</button>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="sg-empty">Loading…</div>
      ) : entries.length === 0 ? (
        <div className="sg-empty">No suppressions yet.</div>
      ) : (
        <div className="sg-panel">
          <table className="sg-table">
            <thead>
              <tr>
                <th>Email</th>
                <th>Domain</th>
                <th>Reason</th>
                <th>Source</th>
                <th>Added</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {entries.map((e) => (
                <tr key={e.id}>
                  <td>{e.email || "—"}</td>
                  <td>{e.domain || "—"}</td>
                  <td>{e.reason || "—"}</td>
                  <td><code style={{ fontSize: 11 }}>{e.source || "—"}</code></td>
                  <td className="sg-muted" style={{ fontSize: 12 }}>{new Date(e.created_at).toLocaleDateString()}</td>
                  <td style={{ textAlign: "right" }}>
                    <button className="sg-btn sg-btn-ghost sg-btn-sm" onClick={() => remove(e.id)}>Remove</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
